import { cva } from "class-variance-authority"

export const toggleVariants = cva(
  "inline-flex items-center justify-center gap-2 rounded-md text-sm font-medium hover:bg-muted disabled:pointer-events-none disabled:opacity-50 data-[state=on]:bg-accent [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 [&_svg]:shrink-0 focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] outline-none transition-[color,box-shadow] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive whitespace-nowrap",
  {
    variants: {
      variant: {
        ghost: "bg-transparent hover:bg-muted",
        outline: "border border-input bg-transparent shadow-xs hover:bg-accent",
      },
      size: {
        tiny: "h-6 px-1 min-w-6",
        xs: "h-7 px-2 min-w-7",
        sm: "h-8 px-3 min-w-8",
        md: "h-9 px-3 min-w-9",
        lg: "h-10 px-3 min-w-10",
        xl: "h-12 px-3 min-w-12",
      },
      isSquare: {
        true: "px-0 overflow-hidden",
        false: "",
      },
    },
    compoundVariants: [
      { size: "tiny", isSquare: true, class: "w-6 min-h-6" },
      { size: "xs", isSquare: true, class: "w-7 min-h-7" },
      { size: "sm", isSquare: true, class: "w-8 min-h-8" },
      { size: "md", isSquare: true, class: "w-9 min-h-9" },
      { size: "lg", isSquare: true, class: "w-10 min-h-10" },
      { size: "xl", isSquare: true, class: "w-12 min-h-12" },
    ],
    defaultVariants: {
      variant: "outline",
      size: "sm",
      isSquare: false,
    },
  },
)
